import { faCheck, faMinus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { type FC, type MouseEventHandler } from "react";

export const CheckBox: FC<{
  state: "checked" | "unchecked" | "partial";
  onSelect: () => void;
  onDeselect: () => void;
}> = (props) => {
  const handleClick: MouseEventHandler<HTMLButtonElement> = (e) => {
    e.stopPropagation();
    if (props.state === "checked") {
      props.onDeselect();
    } else {
      props.onSelect();
    }
  };
  return (
    <button
      onClick={handleClick}
      type={"button"}
      className={"ml-2 -mr-2 hover:bg-brand-50 rounded-full flex items-center justify-center"}
    >
      <div
        className={`h-4 w-4 mx-3 my-3 flex items-center justify-center rounded-sm border-2 ${props.state === "unchecked" ? "border-slate-500 bg-transparent" : "border-brand-900 bg-brand-900 text-white"}`}
      >
        {props.state === "checked" && <FontAwesomeIcon icon={faCheck} className={"w-3"} />}
        {props.state === "partial" && <FontAwesomeIcon icon={faMinus} className={"w-3"} />}
      </div>
    </button>
  );
};
